var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 469297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 469296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2995-1-0",
    d: "M25.5696 13.0002C25.5696 20.0103 19.892 25.6879 12.8819 25.6879C5.87182 25.6879 0.194702 20.0098 0.194702 13.0002C0.194702 5.9906 5.87231 0.3125 12.8824 0.3125C19.8925 0.3125 25.5701 5.99011 25.5701 13.0002H25.5696Z",
    fill: "url(#paint0_linear_10853_3741)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2993",
    d: "M10.3643 19.3434C9.9474 19.3434 10.0221 19.1795 9.87223 18.7748L8.65314 14.6624L16.2239 9.82812L17.1116 10.0689L16.3737 12.1251L10.3638 19.3439L10.3643 19.3434Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2989",
    d: "M10.7681 19.3442C11.0703 19.3442 11.2012 19.1719 11.3721 18.9752C11.6338 18.6676 14.9969 14.6722 14.9969 14.6722L12.9325 14.0576L11.0196 15.533L10.7676 19.2213V19.3442H10.7681Z",
    fill: "#A9C9DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2991",
    d: "M10.8594 15.7508L15.9565 19.2007C16.5356 19.4907 16.9569 19.3455 17.1045 18.7077L19.1794 9.74006C19.3898 8.95748 18.8531 8.60932 18.2949 8.84128L6.12079 13.151C5.28889 13.4603 5.29912 13.8853 5.97321 14.069L9.10112 14.9678L16.3359 10.7836C16.673 10.5906 16.9891 10.6965 16.7363 10.9092L10.8599 15.7508H10.8594Z",
    fill: "url(#paint1_linear_10853_3741)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10853_3741",
    x1: 16.5904,
    y1: 4.3124,
    x2: 10.2641,
    y2: 19.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10853_3741",
    x1: 13.9864,
    y1: 13.9429,
    x2: 16.3023,
    y2: 17.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/TelegramLogo.0bb47ab969f405cc96ef91a287670123.svg";
export { ForwardRef as ReactComponent };